import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { TextField } from '@statsbomb/kitbag-components';
import { isEmpty } from 'lodash';
import {
  SearchResultHolder,
  SearchResults,
  SearchResultsLoading,
  SearchWithList,
} from '../BiometricFilters.styles';
import { SCOUT_BIOMETRIC_FILTERS } from '../../ScoutResults.constants';
import { biometricProp } from '../../../Scout.proptypes';
import { useSearchColleges } from '../hooks/useSearchColleges';
import BiometricChips from './BiometricChips';
import BiometricListItem from './BiometricListItem';
import LoaderInline from '../../../../../components/LoaderInline/LoaderInline';

const TeamAttendedMultiselect = ({
  selectedBiometrics,
  setSelectedBiometrics,
}) => {
  const collegesAttendedFilter = selectedBiometrics.find(
    (b) => b.key === SCOUT_BIOMETRIC_FILTERS.collegesAttended.key
  );

  const currentTokens = isEmpty(collegesAttendedFilter?.tokens)
    ? []
    : [...collegesAttendedFilter.tokens];

  const [searchValue, setSearchValue] = useState('');
  const trimmedSearchValue = (searchValue || '').trim();

  const { collegeTeams, isLoading } = useSearchColleges(trimmedSearchValue);

  const CollegeListItem = (collegeTeam) => {
    const { name, shortName, id: teamId } = collegeTeam;
    const teamName = `${shortName}, ${name}`;

    const lIToken = { id: teamId, name: teamName };

    return (
      <BiometricListItem
        selectedBiometrics={selectedBiometrics}
        setSelectedBiometrics={setSelectedBiometrics}
        biometricKey={SCOUT_BIOMETRIC_FILTERS.collegesAttended.key}
        currentTokens={currentTokens}
        searchResultToken={lIToken}
        onSelected={() => setSearchValue('')}
      />
    );
  };

  const adornment = trimmedSearchValue.length > 0 ? 'Close' : 'Search';

  return (
    <SearchWithList>
      <h3>College attended </h3>
      <TextField
        id="colleges-attended-search-filter"
        labelPosition="none"
        value={searchValue}
        onChange={(e) => setSearchValue(e.target.value)}
        adornmentIcon={adornment}
        adornmentOnClick={() => {
          if (trimmedSearchValue.length > 0) {
            setSearchValue('');
          }
        }}
        placeholder="Search for a college team"
        size="small"
      />
      {trimmedSearchValue.length > 0 && (
        <SearchResultHolder>
          {isLoading && (
            <SearchResultsLoading>
              <LoaderInline text="Loading Data" />
            </SearchResultsLoading>
          )}
          <SearchResults>{collegeTeams?.map(CollegeListItem)}</SearchResults>
        </SearchResultHolder>
      )}
      <BiometricChips
        selectedBiometrics={selectedBiometrics}
        setSelectedBiometrics={setSelectedBiometrics}
        biometricKey={SCOUT_BIOMETRIC_FILTERS.collegesAttended.key}
        tokens={currentTokens}
      />
    </SearchWithList>
  );
};
TeamAttendedMultiselect.propTypes = {
  // list of currently selected biometric filters
  selectedBiometrics: PropTypes.arrayOf(biometricProp).isRequired,
  // function to update the selected biometrics
  setSelectedBiometrics: PropTypes.func.isRequired,
};

export default TeamAttendedMultiselect;
